import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { ksefApi, KSeFLogDto } from "./ksefApi";
import { BaseApiPaging } from "api/types";

export const useKsefLogs = (integrationId: number, skip: number = 0, take: number = 50) => {
  const { isLoading, data, refetch } = useQuery<BaseApiPaging<KSeFLogDto>>({
    queryKey: QUERIES_KEYS.KSEF_LOGS(integrationId, skip, take),
    queryFn: () => ksefApi.fetchLogs(integrationId, skip, take).then((r) => r.data),
    enabled: integrationId > 0,
    refetchInterval: 5000,
  });

  return { isLoading, logs: data?.data ?? [], total: data?.total ?? 0, refetch };
};
